export default "__VITE_ASSET__TzqM7SEt__"